import { EventLogViewer } from 'edge-stream-js-react'

export function EventViewerPage() {
  return (
    <div className="page-container">
      <h2>Event Stream</h2>
      <p className="page-description">Monitor real-time event stream from EdgeStream</p>
      <EventLogViewer autoScroll={false} />
    </div>
  )
}
